var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"utterances",style:({height: _vm.height}),attrs:{"id":"comment"}},[_c('iframe',{staticClass:"utterances-frame",attrs:{"title":"BruceIT评论系统","scrolling":"no","allowtransparency":"true","src":_vm.page}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b4c6b1e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/web/components/article/comment.vue
// module id = 63
// module chunks = 4 5